var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 22a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0-15.25a1 1 0 0 1 1 1v7.5a1 1 0 1 1-2 0v-7.5a1 1 0 0 1 1-1m.75 11.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0",
    clipRule: "evenodd"
  })));
});
const SvgCircleAlert = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircleAlert);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTIgMjJDMTYuOTcwNiAyMiAyMSAxNy45NzA2IDIxIDEzQzIxIDguMDI5NDQgMTYuOTcwNiA0IDEyIDRDNy4wMjk0NCA0IDMgOC4wMjk0NCAzIDEzQzMgMTcuOTcwNiA3LjAyOTQ0IDIyIDEyIDIyWk0xMiA2Ljc1QzEyLjU1MjMgNi43NSAxMyA3LjE5NzcyIDEzIDcuNzVWMTUuMjVDMTMgMTUuODAyMyAxMi41NTIzIDE2LjI1IDEyIDE2LjI1QzExLjQ0NzcgMTYuMjUgMTEgMTUuODAyMyAxMSAxNS4yNVY3Ljc1QzExIDcuMTk3NzIgMTEuNDQ3NyA2Ljc1IDEyIDYuNzVaTTEyLjc1IDE4LjI1QzEyLjc1IDE4LjY2NDIgMTIuNDE0MiAxOSAxMiAxOUMxMS41ODU4IDE5IDExLjI1IDE4LjY2NDIgMTEuMjUgMTguMjVDMTEuMjUgMTcuODM1OCAxMS41ODU4IDE3LjUgMTIgMTcuNUMxMi40MTQyIDE3LjUgMTIuNzUgMTcuODM1OCAxMi43NSAxOC4yNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4=";